export default {
  whatsAppApiUrl: 'https://web.whatsapp.com/send?',
};
